import React from 'react';

interface LiveIndicatorProps {
  /** The live demo URL to open when clicked */
  liveDemoUrl: string;
}

/**
 * Visual badge indicating an active live demo.
 * Shows a pulsing green dot + "Live" text. Clicking opens the live URL in a new tab.
 */
export const LiveIndicator: React.FC<LiveIndicatorProps> = ({ liveDemoUrl }) => {
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    window.open(liveDemoUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <button
      onClick={handleClick}
      aria-label="Open live demo in new tab"
      className="live-badge"
    >
      <span className="live-badge__dot" aria-hidden="true" />
      Live
    </button>
  );
};
